import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import fetchBase from "../utils/fetchBase";
import "../pages/EmployeeDashboard.css";

const EmployeeNav = () => {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        const authHeader = "Bearer " + localStorage.getItem("jwt_token");
        fetch(`${fetchBase}/api/notifications/unread-count`, {
            headers: { Authorization: authHeader }
        })
            .then(res => res.json())
            .then(data => {
                if (data && typeof data.count === "number") setUnreadCount(data.count);
            })
            .catch(err => console.error("Failed to fetch unread count:", err));
    }, []);

    return (
        <>
            <nav className="apple-global-nav">

                <div className="left-nav">
                    <img src="/images/logoPlaceholder1.png" alt="Logo" className="apple-logo"/>
                </div>

                <div className="center-nav">
                    <a href="/employee/dashboard">Dashboard</a>
                </div>

                <div className="notification-bell-container" style={{ position: "relative", marginRight: "16px", cursor: "pointer" }} onClick={() => navigate("/employee/notifications")}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6e6e73" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                    </svg>
                    {unreadCount > 0 && (
                        <span style={{
                            position: "absolute", top: "-6px", right: "-8px",
                            background: "#ff3b30", color: "white", fontSize: "10px",
                            fontWeight: "700", borderRadius: "10px", padding: "1px 5px",
                            minWidth: "14px", textAlign: "center"
                        }}>
                            {unreadCount}
                        </span>
                    )}
                </div>

                <div className="account-dropdown-container">
                    <span className="account-link">Account ▾</span>
                    <div className="account-dropdown">
                        <a href="/employee/history">History</a>
                        <a href="/employee/manual">Manual</a>
                        <a href="/logout">Log Out</a>
                    </div>
                </div>

                <button
                    className={`hamburger-btn ${menuOpen ? "open" : ""}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>

            </nav>

            {menuOpen && (
                <div className="admin-mobile-menu">
                    <a href="/employee/dashboard" onClick={() => setMenuOpen(false)}>Dashboard</a>
                    <a href="/employee/history" onClick={() => setMenuOpen(false)}>History</a>
                    <a href="/employee/document-hub" onClick={() => setMenuOpen(false)}>Document Hub</a>
                    <a href="/employee/timesheets" onClick={() => setMenuOpen(false)}>Timesheets</a>
                    <a href="/employee/manual" onClick={() => setMenuOpen(false)}>Manual</a>
                    <a href="/logout" onClick={() => setMenuOpen(false)}>Log Out</a>
                </div>
            )}
        </>
    );
};

export default EmployeeNav;